import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  private userUpdateSource = new BehaviorSubject<boolean>(false);
  userUpdate$ = this.userUpdateSource.asObservable();

  triggerUserUpdate() {
    this.userUpdateSource.next(true);
  }
}